import type { IconData } from '@stacksjs/iconify-core'

export const natureLightning: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 10H0L10 0v6h6L6 16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureLightning
